import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

/**
 * Service to dynamically manage layout classes on the document body.
 */
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private renderer: Renderer2;
  private readonly layoutClasses: string[] = [
    'layout-12', 'layout-39', 'layout-93', 
    'layout-66', 'layout-363', 'layout-3333'
  ];
  private currentClass: string | null = null;
  private readonly fullWidthClass: string = 'full-width';
  private isFullWidth: boolean = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Sets a layout class on the document body, removing the previous one if necessary.
   * @param className The new class to set.
   */
  setClass(className: string): void {
    if (!this.layoutClasses.includes(className)) return;
    this.updateClass(this.currentClass, className);
    this.currentClass = className;
  }

  /**
   * Toggles the 'full-width' class on the document body.
   */
  toggleFullWidth(): void {
    this.isFullWidth = !this.isFullWidth;
    this.updateClass(this.isFullWidth ? null : this.fullWidthClass, this.isFullWidth ? this.fullWidthClass : null);
  }

  /**
   * Updates the class on the document body, removing the old class if it exists and adding the new class.
   * @param oldClass The class to remove.
   * @param newClass The class to add.
   */
  private updateClass(oldClass: string | null, newClass: string | null): void {
    if (oldClass) this.renderer.removeClass(document.body, oldClass);
    if (newClass) this.renderer.addClass(document.body, newClass);
  }
}